import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAppContext } from '../context/AppContext';

const MeasurementsContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
  
  h1 {
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 10px;
  }
`;

const MeasurementsCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-bottom: 30px;
`;

const MeasurementItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  
  &:last-child {
    border-bottom: none;
  }
  
  .label {
    font-weight: 500;
    color: #333;
  }
  
  .value {
    font-size: 1.1rem;
    color: #666;
  }
`;

const SizeRecommendation = styled.div`
  text-align: center;
  margin: 30px 0;
  
  h2 {
    margin-bottom: 10px;
  }
  
  .size {
    font-size: 3rem;
    font-weight: bold;
    color: #4a90e2;
  }
  
  .note {
    margin-top: 10px;
    color: #666;
  }
`;

const Button = styled.button`
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  margin-top: 20px;
  
  &:hover {
    background-color: #357abD;
  }
`;

const EstimateWarning = styled.div`
  background-color:rgb(27, 27, 26);
  color: #856404;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
`;

const MeasurementsPage = () => {
  const navigate = useNavigate();
  const { measurements, recommendedSize, userImage } = useAppContext();
  
  useEffect(() => {
    console.log("MeasurementsPage mounted");
    console.log("Context values:", { measurements, recommendedSize, userImage });
    
    // Redirect to home if no measurements
    if (!measurements || !Object.keys(measurements).length) {
      console.warn("No measurements found, redirecting to home");
      navigate('/');
    }
  }, [measurements, navigate, recommendedSize, userImage]);
  
  const handleTryOn = () => {
    navigate('/try-on');
  };
  
  if (!measurements) {
    return null; // Return null while redirecting
  }
  
  return (
    <MeasurementsContainer>
      <Header>
        <h1>Your Body Measurements</h1>
      </Header>
      
      {measurements.isEstimate && (
        <EstimateWarning>
          Note: These measurements are estimates based on AI analysis. For the most accurate results, we recommend professional measurements.
        </EstimateWarning>
      )}
      
      <MeasurementsCard>
        <MeasurementItem>
          <div className="label">Bust:</div>
          <div className="value">{measurements.bust.toFixed(1)} inches</div>
        </MeasurementItem>
        <MeasurementItem>
          <div className="label">Waist:</div>
          <div className="value">{measurements.waist.toFixed(1)} inches</div>
        </MeasurementItem>
        <MeasurementItem>
          <div className="label">Hips:</div>
          <div className="value">{measurements.hips.toFixed(1)} inches</div>
        </MeasurementItem>
        <MeasurementItem>
          <div className="label">Inseam:</div>
          <div className="value">{measurements.inseam.toFixed(1)} inches</div>
        </MeasurementItem>
        <MeasurementItem>
          <div className="label">Shoulders:</div>
          <div className="value">{measurements.shoulders.toFixed(1)} inches</div>
        </MeasurementItem>
      </MeasurementsCard>
      
      <SizeRecommendation>
        <h2>Your Recommended Size</h2>
        <div className="size">{recommendedSize}</div>
        <div className="note">Based on your measurements, we recommend this size for most clothing items.</div>
      </SizeRecommendation>
      
      <Button onClick={handleTryOn}>
        Try On Clothes Virtually
      </Button>
    </MeasurementsContainer>
  );
};

export default MeasurementsPage;